
function getCookie(name, defaultValue) {
  for (const cookie of document.cookie.split(';')) {
    if (cookie.trim().startsWith(name)) {
      return cookie.trim().replace(`${name}=`, '');
    }
  }
  
  return defaultValue;
}

module.exports = {
  getCookie,
};
